module.exports = __webpack_public_path__ + "img/card_monitoreo.17ebd542.jpg";